import { n as c, e as p, b as u, B as h } from "./abstract-base-CzLmw6_x.js";
import { m as B } from "./lifecycle-decorators-CUsT9aHq.js";
import { B as m } from "./beacon-primitive-ChVMWFlW.js";
import { a as l } from "./query-assigned-K46zQIzj.js";
import { i as f } from "./utils-BSj5iT7c.js";
var v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, a = (s, e, n, o) => {
  for (var t = o > 1 ? void 0 : o ? y(e, n) : e, r = s.length - 1, i; r >= 0; r--)
    (i = s[r]) && (t = (o ? i(e, n, t) : i(t)) || t);
  return o && t && v(e, n, t), t;
};
const F = () => function(e) {
  let n = class extends e {
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
    emitInput(o, t) {
      p(this, u.INPUT, !!this.onBeaconInput && this.onBeaconInput(o, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
    emitChange(o, t) {
      p(this, u.CHANGE, !!this.onBeaconChange && this.onBeaconChange(o, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
    emitFocus(o, t) {
      p(this, u.FOCUS, !!this.onBeaconFocus && this.onBeaconFocus(o, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
    emitBlur(o, t) {
      p(this, u.BLUR, !!this.onBeaconBlur && this.onBeaconBlur(o, t));
    }
    /**
     * TODO: No need
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
    emitMousedown(o) {
      p(this, u.MOUSEDOWN, !!this.onBeaconMousedown && this.onBeaconMousedown());
    }
  };
  return a([
    c({ type: Function })
  ], n.prototype, "onBeaconChange", 2), a([
    c({ type: Function })
  ], n.prototype, "onBeaconBlur", 2), a([
    c({ type: Function })
  ], n.prototype, "onBeaconInput", 2), a([
    c({ type: Function })
  ], n.prototype, "onBeaconFocus", 2), a([
    c({ type: Function })
  ], n.prototype, "onBeaconMousedown", 2), n = a([
    B("FormEvents")
  ], n), n;
};
var d = Object.defineProperty, _ = (s, e, n, o) => {
  for (var t = void 0, r = s.length - 1, i; r >= 0; r--)
    (i = s[r]) && (t = i(e, n, t) || t);
  return t && d(e, n, t), t;
};
class C extends m(h, F()) {
  static get formAssociated() {
    return !0;
  }
  constructor() {
    super(), f ? this.internals = null : this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(e, n, o = this.formAnchor) {
    this.internals && this.internals.setValidity(e, n, o);
  }
}
_([
  l(".form-anchor")
], C.prototype, "formAnchor");
export {
  C as B
};
